import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { register } from '../../shared/auth/authentication.actions';
import { Store } from '@ngrx/store';
import { RouterLink } from '@angular/router';
import { IRootState } from '../app.config';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup<{ userName: FormControl<string | null>; email: FormControl<string | null>; password: FormControl<string | null>; confirmPassword: FormControl<string | null>; }> | undefined;

  constructor(private store$: Store<IRootState>) { }

  ngOnInit(): void {
    this.registerForm = new FormGroup({
      userName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required, Validators.minLength(8)]),
      confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8)])
    });
  }

  submit() {
    if (this.registerForm?.valid) {
      if (
        this.registerForm.value &&
        this.registerForm.value.userName &&
        this.registerForm.value.email &&
        this.registerForm.value.password &&
        this.registerForm.value.confirmPassword &&
        this.registerForm.value.password === this.registerForm.value.confirmPassword
      ) {
        this.store$.dispatch(register({ userName: this.registerForm.value.userName, email: this.registerForm.value.email, password: this.registerForm.value.password, confirmPassword: this.registerForm.value.confirmPassword }));
      }
    }
  }
}
